import JobPreviewSection from './JobPreviewSection.component';

export default JobPreviewSection;